import { Injectable } from "@angular/core";
import { env } from "process";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class FacebookPixelService {
  private readonly sentEvents = new Set<string>();
  private activePixelImgs: HTMLImageElement[] = [];

  private getFBP(): string {
    return `fb.1.${Date.now()}.${Math.floor(Math.random() * 1e17)}`;
  }

  private getCommonParams(): Record<string, string> {
    return {
      id: environment.pixelId,
      dl: encodeURIComponent(window.location.href),
      if: "false",
      ts: Date.now().toString(),
      sw: window.screen.width.toString(),
      sh: window.screen.height.toString(),
      v: "2.9.195",
      r: "stable",
      ec: "0",
      o: Math.floor(Math.random() * 5000).toString(),
      fbp: this.getFBP(),
      pm: "1",
      hrl: "fc0132",
      ler: "empty",
      cdl: "API_unavailable",
      it: Date.now().toString(),
      coo: "false",
      cs_cc: "1",
      exp: "k0",
      rqm: "GET",
    };
  }

  private encodeDataParams(data?: Record<string, any>): string {
    if (!data) return "";
    const json = JSON.stringify(data);
    return `&cd=${encodeURIComponent(json)}`;
  }

  private sendPixel(event: string, data?: Record<string, any>): void {
    const dedupKey = event + JSON.stringify(data || {});
    if (this.sentEvents.has(dedupKey)) return;
    this.sentEvents.add(dedupKey);

    const params = this.getCommonParams();
    params["ev"] = event;

    const queryString = Object.entries(params)
      .map(([key, val]) => `${key}=${val}`)
      .join("&");

    const dataParams = this.encodeDataParams(data);
    const pixelUrl = `${environment.pixelUrl}/?${queryString}${dataParams}`;

    const img = new Image();
    img.src = pixelUrl;
    img.width = 1;
    img.height = 1;
    img.style.display = "none";
    img.style.position = "absolute";
    img.style.left = "-9999px";

    document.body.appendChild(img);
    this.activePixelImgs.push(img);

    const cleanup = () => {
      document.body.removeChild(img);
      this.activePixelImgs = this.activePixelImgs.filter((i) => i !== img);
    };

    img.onload = cleanup;
    img.onerror = cleanup;
  }

  trackPageView(): void {
    this.sendPixel("PageView");
  }

  trackCustomEvents(eventName: string, data?: Record<string, any>): void {
    this.sendPixel(eventName, data);
  }

  resetEvents(): void {
    this.sentEvents.clear();
  }

  revokePixel(): void {
    this.activePixelImgs.forEach((img) => {
      if (img.parentNode) {
        img.parentNode.removeChild(img);
      }
    });
    this.activePixelImgs = [];
  }
}
